import { Close } from '@mui/icons-material';
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Button as MuiButton,
} from '@mui/material';
import { formatInTitleCase } from '@utils/constants';

const UpdateRoleConfirmation = ({
  open,
  onClose,
  onConfirm,
  isPending,
  disabled,
  currentSpeaker,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" sx={{ p: 0 }}>
      <DialogTitle
        sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600, height: '56px' }}
      >
        Update Role
        <IconButton onClick={onClose} sx={{ ml: 'auto', cursor: 'pointer' }}>
          <Close sx={{ fontSize: 20 }} />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        Are you sure want to change speaker from{' '}
        <strong>{currentSpeaker?.role === 'interviewer' ? 'Participant' : 'Interviewer'}</strong> to{' '}
        <strong>{formatInTitleCase(currentSpeaker?.role)}</strong> ?
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <MuiButton onClick={onClose} variant="default">
          Cancel
        </MuiButton>
        <MuiButton
          variant="contained"
          onClick={onConfirm}
          color="error"
          disabled={disabled || isPending}
        >
          {isPending ? <CircularProgress size={16} sx={{ mr: 1 }} /> : 'Confirm'}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateRoleConfirmation;
